export const ENTITY_EXPLORER_SEARCH_ID = "entity-explorer-search";
